// This file is for any common CSS that we reuse across pages

import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { breakpointMd, breakpointSm } from "./layout";

// Source: https://getcssscan.com/css-box-shadow-examples
export const boxShadow1 = "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px";
export const boxShadow2 =
  "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px";
export const boxShadow3 =
  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px";
export const boxShadow4 =
  "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px";
export const boxShadow5 =
  "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px";
export const boxShadow6 =
  "rgba(0, 0, 0, 0.03) 0px 8px 16px";

export const Prompt = styled.p`
  margin-top: 0;
`;

export const InputLabel = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
`;

export const profileSectionGalleryStyles = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(160px, 1fr));
  grid-gap: 1rem;

  @media only screen and (min-width: ${breakpointSm}) {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    grid-gap: 1.5rem;
  }
`;

export const rotatingStyles = css`
  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: scaleX(-1) rotate(359deg);
    }
    to {
      transform: scaleX(-1) rotate(0deg);
    }
  }
`;

export const featureGridStyles = css`
  display: grid;
  row-gap: 2rem;
`;

export const featureStyles = css`
  margin: 0 auto;
  max-width: 840px;
  display: grid;
  gap: 2rem;
  padding: 1.5rem 1rem 1rem 1rem;
  border-radius: 1rem;

  h2 {
    margin: 0 0 1rem 0;
  }

  .feature-text {
    border-radius: 0.5rem;

    p {
      margin-bottom: 0;
    }
  }

  .screenshot-container {
    margin: 0 auto;
  }

  .screenshot {
    box-sizing: border-box;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 8%);
    border-radius: 0.5rem;
  }

  .img-container {
    justify-self: center;
    border-radius: 1rem;
  }

  @media only screen and (min-width: ${breakpointSm}) {
    .img-container {
      max-width: 350px;
    }
  }

  @media only screen and (min-width: ${breakpointMd}) {
    padding: 2rem;
    grid-template-columns: 2fr 1fr;

    .screenshot-container {
      top: 0;
      margin: 0;
      float: right;
    }

    .img-container {
      justify-self: end;
    }
  }
`;

export const featureRightStyles = css`
  @media only screen and (min-width: ${breakpointMd}) {
    grid-template-columns: 1fr 2fr;
    grid-template-areas: "image text";

    .screenshot-container {
      float: unset;
    }

    .img-container {
      grid-area: image;
      justify-self: start;
    }
  }
`;
